import React from "react"
import { Card, CardHeader, CardText } from "material-ui/Card"


export default props => (
    <Card className="card">
        <CardHeader title="Thank you!" />
        <CardText>
            <p>
                We have sent you an email with an activation link.
            </p>
        </CardText>
    </Card>
)


/** WEBPACK FOOTER **
 ** ./src/components/user/SignUp/thank-you.js
 **/